import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { HandOrderGrantFlyOverlay } from './HandOrderGrantFlyOverlay';

/**
 * Flies multiple hand grants from the same provider slot in sequence (Stinger Commander).
 */
export const HandOrderGrantFlyBatchOverlay = ({
  grant,
  orders,
  cardScale = 1,
  mobileOuterScale = 1,
  isMobileHand = false,
  gameState = null,
  userId = null,
  onStepComplete,
  onComplete,
}) => {
  const [stepIndex, setStepIndex] = useState(0);
  const onStepCompleteRef = useRef(onStepComplete);
  const onCompleteRef = useRef(onComplete);
  const batchFinishedRef = useRef(false);

  useLayoutEffect(() => {
    onStepCompleteRef.current = onStepComplete;
  }, [onStepComplete]);

  useLayoutEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  const batchGrants = grant?.batchGrants;
  const currentGrant = batchGrants?.[stepIndex];
  const currentOrder = orders?.[stepIndex];

  const handleStepComplete = useCallback(() => {
    if (!batchGrants?.length) {
      return;
    }
    setStepIndex((prev) => {
      const finishedGrant = batchGrants[prev];
      if (finishedGrant?.orderInstanceId != null) {
        onStepCompleteRef.current?.(finishedGrant.orderInstanceId);
      }
      if (prev + 1 >= batchGrants.length) {
        if (!batchFinishedRef.current) {
          batchFinishedRef.current = true;
          onCompleteRef.current?.();
        }
        return prev;
      }
      return prev + 1;
    });
  }, [batchGrants]);

  if (!grant || !batchGrants?.length || !currentGrant || !currentOrder) {
    return null;
  }

  return (
    <HandOrderGrantFlyOverlay
      key={`${grant.key}-step-${stepIndex}-${currentGrant.orderInstanceId}`}
      grant={currentGrant}
      order={currentOrder}
      cardScale={cardScale}
      mobileOuterScale={mobileOuterScale}
      isMobileHand={isMobileHand}
      gameState={gameState}
      userId={userId}
      onComplete={handleStepComplete}
    />
  );
};
